import { App } from './ps20apps';

export interface ProduktLike {
  appId?: App;
  angebotsId?: string;
  beibehalten?: boolean;
}

export interface SavedStateLike {
  appId?: App;
  angebotsId?: string;
  state?: { produkte?: Array<ProduktLike> };
}

export function isBeibehalten(produkt: ProduktLike | null | undefined): boolean {
  return produkt?.beibehalten === true;
}

export function getProtectedAngebotsIds(
  savedStates: ReadonlyArray<SavedStateLike> | null | undefined,
  checkoutAppId: App,
): Set<string> {
  const protectedIds = new Set<string>();
  if (!Array.isArray(savedStates)) {
    return protectedIds;
  }
  const checkoutWrapper = savedStates.find(entry => entry?.appId === checkoutAppId);
  const produkte = checkoutWrapper?.state?.produkte ?? [];
  for (const produkt of produkte) {
    if (produkt?.angebotsId && isBeibehalten(produkt)) {
      protectedIds.add(produkt.angebotsId);
    }
  }
  return protectedIds;
}

export function isEntryProtectedOrActive(
  entry: { appId?: App; angebotsId?: string } | null | undefined,
  inactiveApps: ReadonlyArray<App>,
  protectedAngebotsIds: ReadonlySet<string>,
): boolean {
  if (!entry) {
    return false;
  }
  if (!inactiveApps.includes(entry.appId)) {
    return true;
  }
  return !!entry.angebotsId && protectedAngebotsIds.has(entry.angebotsId);
}
